<template>
  <div>
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardHeader>
            <strong>Riwayat Transaksi</strong>
            <div class="card-header-actions">
              <ButtonLoader 
                  :loading="loading.refresh" 
                  :styled="'btn btn-info btn-sm btn-block'" 
                  @click.native="getTransaction()">
                    Refresh
                </ButtonLoader>
            </div>
          </CCardHeader>
          <CCardHeader>
            <div :class="{'loading-card' : loading.card}">
              <span style="font-size:14px;">Menampilkan <b>{{ transaction.data.length }}</b> dari <b>{{ transaction.total }}</b> Data</span>
            </div>
          </CCardHeader>
          <CCardBody class="p-0">
            <div class="table-responsive" :class="{'loading-card' : loading.card}">
              <table class="table table-sm table-bordered table-hover mb-0">
                <thead style="font-size:14px;">
                  <tr class="table-secondary">
                      <th class="text-center text-nowrap">Tanggal</th>
                      <th class="text-nowrap">Type</th>
                      <th>Pesan</th>
                      <th class="text-nowrap">Ke</th>
                      <th class="text-nowrap">Biaya</th>
                      <th class="text-nowrap">Sender</th>
                      <th class="text-nowrap">Status</th>
                      <!-- <th class="text-center">Action</th> -->
                  </tr>
                </thead>
                <tbody v-if="transaction.data.length > 0" style="font-size:12px;">
                  <tr v-for="(item) in transaction.data" :key="item.id">
                      <td class="text-center text-nowrap pl-3">{{ item.created_at }}<br>{{ item.updated_at }}</td>
                      <td class="text-nowrap">{{ item.product_name }}</td>
                      <td>{{ item.message }}</td>
                      <td class="text-nowrap">{{ item.to }}</td>
                      <td class="text-nowrap">{{ item.cost }} Credit</td>
                      <td class="text-nowrap">{{ item.sender }}</td>
                      <td class="pr-3">
                        <CBadge color="warning" v-if="item.status == 'PENDING'">Pending</CBadge>
                        <CBadge color="success" v-else-if="item.status == 'SUCCESS'">Berhasil</CBadge>
                        <CBadge color="danger" v-else-if="item.status == 'FAILED'">Failed</CBadge>
                      </td>
                      <!-- <td class="text-center">
                        <button class="btn btn-primary btn-sm" style="font-size:11px;">
                          Resend
                        </button>
                      </td> -->
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                      <td colspan="8" class="text-center"><small><i>Data tidak ditemukan</i></small></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </CCardBody>
          <div class="card-footer" v-if="transaction.data.length > 0">
            <div class="float-left">
                <Pagination :pagination="transaction" @paginate="getTransaction();" :offset="2">
                </Pagination>
            </div>
          </div>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import $axios from './../../../api.js'
export default {
  name: 'history.transaction.data',
  data(){
    return {
      alert:{
        show: false,
        content: ''
      },
      loading: {
        refresh: false,
        card: true
      },
      transaction: {
          data: [],
          current_page: 1,
          total: 0
      },
    }
  },
  created(){
    
  },
  computed:{
    ...mapState(['setting','errors'])
  },
  methods:{
    getTransaction(){
      this.loading.refresh = true
      this.loading.card = true
      $axios.get('/history/transaction', {
        params:{
          page: this.transaction.current_page
        }
      })
      .then((response) => {
        this.loading.card = false
        this.loading.refresh = false
        this.transaction = response.data.data
      }).catch((error) => {
        this.loading.card = false
        this.loading.refresh = false
      })
    },
    // submit(){
    //   this.loading.submit = true
    //   this.$store.commit('CLEAR_ERRORS')
    //   this.alert = {
    //         show: false,
    //         content: ''
    //       }
    //   $axios.post('/deposit', this.data)
    //   .then((response) => {
    //     this.loading.submit = false
    //   }).catch((error) => {
    //     this.loading.submit = false
    //     if (error.response.status == 422) {
    //       this.$store.commit('SET_ERRORS', error.response.data.errors, { root: true })
    //     }else{
    //       this.alert = {
    //         show: true,
    //         content: error.response.data.message
    //       }
    //     }
    //   })
    // }
  },
  mounted(){
    
    this.getTransaction()
  }
}
</script>
